<template>
  <div class="container visitReportAdd">
    <div class="searchBox">
      <div class="searchBox_top">
        <template v-if="showButton">
          <el-button type="primary" v-acl="Msv-reportSave" v-if="isSave" @click="saveVisit('queryCondition')">{{$t('visitPlan.draftSave')}}</el-button>
          <el-button v-acl="Msv-reportSubmit" type="primary" v-if="isSubmit" @click="submitVisitPlan('queryCondition')">{{$t('common.submit')}}</el-button>
        </template>
        <el-button type="primary" @click="goBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
        <template v-if="showButton && isSave" v-acl="Msv-reportSave">
          <br />
          <label style="font-size:12px;color:#F56C6C;">{{$t('visitPlan.operationTips')}}</label>
        </template>
      </div>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('visitPlan.ReportDetails')" name="first">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>MSV Basic Info</span>
          </div>
          <el-form :model="queryCondition" ref="queryCondition" :rules="queryConditionRules" inline label-width="240px">
            <el-form-item label="MSV 单据编号" prop="msvNo">
              <!--计划单据编号-->
              <el-input v-model.trim="queryCondition.msvNo" disabled clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.Year')" prop="year" :rules="fromVisitPlan ? queryConditionRules.year2 : queryConditionRules.year">
              <!--拜访年份-->
              <el-date-picker v-model="queryCondition.year" type="year" clearable value-format="yyyy" :disabled="fromVisitPlan" placeholder="选择年"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.Type')" prop="type" :rules="fromVisitPlan ? queryConditionRules.type2 : queryConditionRules.type">
              <!--供应商类型-->
              <el-input v-model="queryCondition.type" readonly disabled v-if="isHGS"></el-input>
              <el-select v-model="queryCondition.type" clearable :disabled="fromVisitPlan" v-if="!isHGS" @change="typeChange">
                <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Category" prop="category" :rules="istypeFood ? queryConditionRules.category : queryConditionRules.category2">
              <!--Category-->
              <el-select v-model="queryCondition.category" clearable :disabled="fromVisitPlan" @change="CategoryChange">
                <el-option :key="index" v-for="(item,index) in categoryList" :label="item.NAME" :value="item.NAME"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.SupplierFacility')" prop="plantName" :rules="fromVisitPlan ? queryConditionRules.plantName2 : queryConditionRules.plantName">
              <!--供应商工厂-->
              <el-input v-model="queryCondition.plantName" :disabled="fromVisitPlan" clearable>
                <el-button slot="append" icon="el-icon-search" @click="searchSupplier(fromVisitPlan)"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.ReportBy')" prop="createBy">
              <el-input v-model="createBy" disabled></el-input>
            </el-form-item>
            <el-form-item label="Report date" prop="createDate">
              <!--创建时间-->
              <el-date-picker type="date" v-model="queryCondition.createDate" disabled></el-date-picker>
            </el-form-item>
            <el-form-item label="Visit Type" prop="visitType">
              <el-select v-model="queryCondition.visitType" clearable :disabled="otherInput">
                <el-option :key="index" v-for="(item,index) in visitTypeList" :label="item.chineseValue" :value="item.code" :disabled="otherInput"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Report to（Supplier）" prop="supplierEmail" class="ReportTo textareaClass">
              <el-input type="textarea" v-model="queryCondition.supplierEmail" clearable :disabled="otherInput" maxlength="400" :autosize="{ minRows:3, maxRows: 6}" placeholder="多个邮箱用英文逗号隔开"></el-input>
              <div class="smallIcons" @click="searchSupplierEmail(otherInput)">
                <i class="el-icon-search"></i>
              </div>
            </el-form-item>
            <el-form-item label="Report to（McD）" prop="mcdEmail" class="ReportTo textareaClass">
              <el-input type="textarea" v-model="queryCondition.mcdEmail" clearable :disabled="otherInput" maxlength="400" :autosize="{ minRows:3, maxRows: 6}" placeholder="多个邮箱用英文逗号隔开"></el-input>
              <div class="smallIcons" @click="searchMcD(otherInput)">
                <i class="el-icon-search"></i>
              </div>
            </el-form-item>
            <el-form-item label="Attendees Supplier" prop="attendeesSupplier">
              <el-input type="textarea" v-model="queryCondition.attendeesSupplier" :autosize="{ minRows:3, maxRows: 6}" clearable :disabled="otherInput"></el-input>
            </el-form-item>
            <el-form-item min-width="200" label="Attendees McDonald’s(& On behalf)" prop="attendeesMcd">
              <el-input type="textarea" v-model="queryCondition.attendeesMcd" :autosize="{ minRows:3, maxRows:6}" clearable :disabled="otherInput"></el-input>
            </el-form-item>
            <el-form-item label="Mgt. recap" prop="mgtRecap">
              <el-select v-model="queryCondition.mgtRecap" clearable :disabled="otherInput">
                <el-option :key="index" v-for="(item,index) in mgtRecapList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="MSV Result" prop="msvResult">
              <el-select v-model="queryCondition.msvResult" clearable :disabled="otherInput">
                <el-option :key="index" v-for="(item,index) in msvResultList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-form-item label="On-site observations Number"></el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="High Risk" prop="highScore" class="highScoreClass">
                <el-input v-model="queryCondition.highScore" clearable maxLength='5' oninput="value=value.replace(/^\.+|[^\d.]/g,'')" @blur="highScoreChange" :disabled="otherInput"></el-input>
              </el-form-item>
              <el-form-item label="Medium Risk" prop="mediumScore" class="ScoreClass">
                <el-input v-model="queryCondition.mediumScore" clearable maxLength='5' oninput="value=value.replace(/^\.+|[^\d.]/g,'')" @blur="mediumScoreChange" :disabled="otherInput"></el-input>
              </el-form-item>
              <el-form-item label="Low Risk" prop="lowScore" class="ScoreClass">
                <el-input v-model="queryCondition.lowScore" clearable maxLength='5' oninput="value=value.replace(/^\.+|[^\d.]/g,'')" @blur="lowScoreChange" :disabled="otherInput"></el-input>
              </el-form-item>
            </el-row>
            <el-form-item label="CAP Implementation  Status" prop="capImplementationStatus">
              <el-select v-model="queryCondition.capImplementationStatus" :disabled="!AllInput">
                <el-option :key="index" v-for="(item,index) in capImplementationStatusList" :label="item.chineseValue" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('visitPlan.VisitDate')" prop="dataArr" class="VisitDate" :rules="queryConditionRules.dataArr">
              <!-- 拜访日期 -->
              <el-date-picker v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable value-format="yyyy-MM-dd" :disabled="otherInput"></el-date-picker>
            </el-form-item>
          </el-form>
          <div class="toolsBox">
            <!-- 1496 拜访报告--CQS端：提交拜访报告后，详情界面的新增拜访主题、删除按钮不应显示 -->
            <el-button size="small" type="primary" v-acl="Msv-reportAddSubject" v-if="showButton && !otherInput" @click="addSubject">新增拜访主题</el-button>
            <el-button size="small" type="danger" v-acl="Msv-reportDelSubject" v-if="showButton && !otherInput" @click="delSubject">删除</el-button>
            <!-- 已经提交不能删除 -->
          </div>
          <el-table :data="PurposeList" ref="PurposeList" border fit class="purposeList">
            <el-table-column type="selection" min-width="50"></el-table-column>
            <el-table-column prop="serialNumber" label="序号" width="60"></el-table-column>
            <el-table-column show-overflow-tooltip prop="visitPurpose" :label="$t('visitPlan.visitPurpose')">
              <template slot-scope="scope">
                <el-autocomplete class="inline-input" v-model="scope.row.visitPurpose" :fetch-suggestions="querySearch" maxlength="200" placeholder="请输入内容" clearable :disabled="otherInput"></el-autocomplete>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card class="box-card" style="margin-top:20px">
          <div slot="header" class="clearfix">
            <span>附件</span>
          </div>
          <el-tabs v-model="activeName2">
            <el-tab-pane label="CQS附件" name="first">
              <el-table :data="fileList" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFileFDP(scope.row)">{{scope.row.documentName}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="tmDocumentId" min-width="130px" v-if="isdeleteFile">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,fileList)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <template>
                <el-upload v-show="showAccessories" style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :before-upload="beforePDFUpload" :show-file-list="false" multiple accept=".PDF" name="file">
                  <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
                </el-upload>
              </template>
            </el-tab-pane>
            <el-tab-pane label="供应商附件" name="second">
              <el-table :data="fileList2" border highlight-current-row class="table">
                <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
                <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
                  <template slot-scope="scope">
                    {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-tab-pane>
      <el-tab-pane :label="$t('visitPlan.ModifyLog')" name="second">
        <el-table :data="logList" ref="logList" border fit>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.operation')" width="120"></el-table-column>
          <el-table-column show-overflow-tooltip prop="detail" :label="$t('common.ModifyContent')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime')" width="100">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="creater" :label="$t('common.OperatorName')" width="120"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier v-if="DestroyIncomeStatistics == true" ref="supplierSelRef" :categoryLevel1Name="categoryLevel1Name" :categoryLevel2Name="categoryLevel2Name" @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
    <el-dialog :visible.sync="showSupplierUserDialog" append-to-body width="80%">
      <SupplierEmail @input="selectSupplierEmail" :multi="true" :emplFlag="'SUP'"></SupplierEmail>
    </el-dialog>
    <el-dialog :visible.sync="showUserDialog" append-to-body width="80%">
      <PickupUser @input="selectMcD" :multi="true" :emplFlag="'MCD'"></PickupUser>
    </el-dialog>
  </div>
</template>
<script>
import {
  getVisitReportList,
  PDFfileUpload,
  saveReport,
  addVisitPlanReportInit,
  submitReport,
  reportDetail,
  getVisitPlanDetailInit,
  getVisitReportLogList,
  updateMsvDetailMonth,
  getCategoryValue,
  visitPlanDetailAddSeach
} from "@/api/visitPlan.js";
import { fileService } from "@/api/common/file-utils";
import SupplierEmail from "@/components/page/visitPlan/SupplierEmail";
import PickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils";
import SelSupplier from "@/components/page/visitPlan/supplierFactory";
import { Message } from "element-ui";
import store from "@/store";
import commonFun from "@/utils/commonFun";
export default {
  name: "",
  components: { SelSupplier, PickupUser, SupplierEmail },
  data() {
    var NoEmpty = (rule, value, callback) => {
      if (!value) callback(new Error(this.$t("visitPlan.noEmpty")));
      else {
        callback();
      }
    };
    var supplierCodeNoEmpty = (rule, value, callback) => {
      if (commonFun.isEmpty(value))
        callback(new Error(this.$t("visitPlan.noEmpty")));
      else {
        callback();
      }
    };
    var validationMailbox = (rule, value, callback) => {
      if (commonFun.isEmpty(this.queryCondition.supplierEmail)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let arr = this.queryCondition.supplierEmail.split(/[,|，|;|；]/);
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      let flag = true;
      arr.forEach(item => {
        if (!reg.test(item)) {
          flag = false;
        }
      });
      if (!flag) callback(this.$t("sys.userList.inputEmail"));
      else {
        callback();
      }
    };
    var validationMailbox2 = (rule, value, callback) => {
      if (commonFun.isEmpty(this.queryCondition.mcdEmail)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let arr = this.queryCondition.mcdEmail.split(/[,|，|;|；]/);
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      let flag = true;
      arr.forEach(item => {
        if (!reg.test(item)) {
          flag = false;
        }
      });
      if (!flag) callback(this.$t("sys.userList.inputEmail"));
      else {
        callback();
      }
    };

    // var categoryNoEmpty = (rule, value, callback) => {
    //   console.log(this.queryCondition.type)
    //   if (value=='')
    //      callback(new Error(this.$t("visitPlan.noEmpty")));
    //   else {
    //     callback();
    //   }
    // };

    return {
      showSelSupplierDialog: false,
      showUserDialog: false,
      showSupplierUserDialog: false,
      DestroyIncomeStatistics: "",
      DestroyUserDialog: "",
      fromVisitPlan: false,
      otherInput: false,
      AllInput: false,
      ttMsvReportId: "",
      uploadFileList: [],
      activeName: "first",
      activeName2: "first",

      totalCount: 0,
      PurposeList: [], //拜访目的
      riskLevelList: "",
      queryCondition: {
        type: "",
        capImplementationStatus: "",
        visitBeginDate: "",
        visitEndDate: "",
        supplierEmail: "",
        mcdEmail: "",
        attendeesSupplier: "",
        attendeesMcd: "",
        mgtRecap: "",
        msvResult: "",
        highScore: "",
        mediumScore: "",
        lowScore: "",
        pageSize: 15,
        pageNum: 1,
        createDate: "",
        supplierCode: "",
        plantName: "",
        category: "",
        tmSupplierId: "",
        createBy: "",
        visitType: "",
        dataArr: ""
      },
      categoryLevel1Name: "",
      categoryLevel2Name: "",
      isSubmit: false,
      isdeleteFile: true,
      isSave: true,
      showAccessories: false,
      showButton: true,
      rows: [],
      Categorylevel: true,
      typeList: [],
      visitTypeList: [],
      logList: [],
      mgtRecapList: [],
      msvResultList: [],
      visitPurposeList: [],
      addPlanDetailsTable: [],
      capImplementationStatusList: [],
      queryConditionRules: {
        year: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ],
        year2: [{ required: false }],
        type: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
        ],
        type2: [{ required: false }],
        visitType: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
        ],
        category: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
          // { required: true, message: this.$t("visitPlan.noEmpty"), validator: categoryNoEmpty ,trigger: "change" }
        ],
        category2: [{ required: false, trigger: "change" }],
        supplierEmail: [
          { required: true, trigger: "blur", validator: validationMailbox }
        ],
        mcdEmail: [
          { required: true, trigger: "blur", validator: validationMailbox2 }
        ],
        plantName: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
          // { required: true, message: this.$t("visitPlan.noEmpty"),validator: supplierCodeNoEmpty, trigger: "blur" },
          // { required: true, message: this.$t("visitPlan.noEmpty"), validator: supplierCodeNoEmpty ,trigger: "submit" }
        ],
        plantName2: [{ required: false }],
        attendeesSupplier: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ],
        attendeesMcd: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ],
        mgtRecap: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
        ],
        msvResult: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
        ],
        highScore: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ],
        mediumScore: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ],
        lowScore: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ],
        dataArr: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "change"
          }
        ]
      },
      tableList2: [],
      showFileList: [],
      fileList: [],
      fileList2: [],
      categoryList: [],
      ttMsvId: "",
      ttMsvDetailId: "",
      month: null,
      status: "",
      emplFlag: "",
      istypeFood: false,
      isHGS: false,
    };
  },
  computed: {
    selection() {
      return this.$refs.table.selection;
    }
  },
  created() {
    this.createBy = localStorage.getItem("ms_username");
    //用户所属系统
    this.emplFlag = localStorage.getItem("ms_emplFlag");
    var date = new Date();
    this.queryCondition.createDate = this.$options.filters["dateFormatFilter"](
      date
    );
    // if(this.$route.query.ttMsvId){//从拜访计划进来的
    //   this.ttMsvId = this.$route.query.ttMsvId;

    // }
    if (this.$route.query.ttMsvDetailId) {
      //从拜访计划 列表 点击 新增拜访报告进来的
      this.ttMsvId = this.$route.query.ttMsvId;
      this.ttMsvDetailId = this.$route.query.ttMsvDetailId;
      this.month = this.$route.query.month;
      this.visitPlanDetai(this.$route.query.ttMsvDetailId);
    }
    if (this.$route.query.VisitPlanIN) {
      //从拜访计划列表  和拜访报告列表有计划编号的 （年度计划内的拜访报告）
      this.fromVisitPlan = true; //置灰
    }

    if (this.$route.query.ttMsvReportId) {
      //从拜访报告列表过来
      this.ttMsvReportId = this.$route.query.ttMsvReportId;
      this.getDetail(this.$route.query.ttMsvReportId);
      this.getFiles();
      this.getFiles2();
      this.getLogList(this.$route.query.ttMsvReportId);
      // this.getPurposeList()
    } else {
      this.init();
    }
    this.getInputChoiceValues();
    this.isHGS = commonFun.havePermission("IS_HGS");
    if (this.isHGS) {
      this.queryCondition.type = "Package";
      this.typeChange("Package");
    }
  },
  methods: {
    getDetail(id) {
      let that = this;
      reportDetail(id).then(res => {
        let list = res.data.msvReportDetails; //拜访目的
        for (let i = 0, len = list.length; i < len; i++) {
          list[i].ids = i;
        }
        list = list.sort(function (a, b) {
          //return (b.sort + "").localeCompare((a.sort + "")); // 比较非数字类型
          return a.ids <= b.ids ? -1 : 1; // 比较数字类型 倒叙排序
        });
        that.PurposeList = list;
        that.queryCondition.msvNo = res.data.msvNo;
        if (res.data.year != null) {
          that.$set(that.queryCondition, "year", res.data.year.toString());
        } else {
          that.$set(that.queryCondition, "year", "");
        }
        that.queryCondition.type = res.data.type;
        that.queryCondition.supplierCode = res.data.supplierCode;
        that.queryCondition.plantName = res.data.plantName;
        that.queryCondition.category = res.data.category;
        that.queryCondition.tmSupplierId = res.data.tmSupplierId;
        that.queryCondition.createBy = res.data.createBy;
        that.queryCondition.createDate = this.$options.filters[
          "dateFormatFilter"
        ](res.data.createDate);
        that.$set(that.queryCondition, "visitType", res.data.visitType);
        that.$set(that.queryCondition, "supplierEmail", res.data.supplierEmail);
        that.$set(that.queryCondition, "mcdEmail", res.data.mcdEmail);
        that.$set(
          that.queryCondition,
          "attendeesSupplier",
          res.data.attendeesSupplier
        );
        that.$set(that.queryCondition, "attendeesMcd", res.data.attendeesMcd);
        that.$set(that.queryCondition, "mgtRecap", res.data.mgtRecap);
        that.$set(that.queryCondition, "msvResult", res.data.msvResult);
        that.$set(that.queryCondition, "highScore", res.data.highScore);
        that.$set(that.queryCondition, "mediumScore", res.data.mediumScore);
        that.$set(that.queryCondition, "lowScore", res.data.lowScore);
        that.$set(
          that.queryCondition,
          "capImplementationStatus",
          res.data.capImplementationStatus
        );
        if (res.data.visitBeginDate != null) {
          that.$set(
            that.queryCondition,
            "visitBeginDate",
            this.$options.filters["dateFormatFilter"](res.data.visitBeginDate)
          );
          that.$set(
            that.queryCondition,
            "visitEndDate",
            this.$options.filters["dateFormatFilter"](res.data.visitEndDate)
          );
          that.queryCondition.dataArr = [
            this.$options.filters["dateFormatFilter"](res.data.visitBeginDate),
            this.$options.filters["dateFormatFilter"](res.data.visitEndDate)
          ];
        }

        that.createBy = res.data.creater;
        if (res.data.type == "Food") {
          this.istypeFood = true;
          that.getCategory("Food");
        }

        let status = res.data.status;
        this.status = res.data.status;
        //status共7个状态 CQS_DRAFT，CQS_SUBMIT，COMPLETED(审核通过的)，REJECT，SP_DRAFT，SP_SUBMIT,FINAL
        //2037 拜访报告--详情界面：报告状态=CQS提交、CQS已下发、SP草稿、SP提交、取消，详情界面除CAP Implementation Status字段外所有字段应置灰；
        if (status == "CQS_DRAFT") {
          //保存过（草稿状态）
          that.showAccessories = true; //保存过附件才能上传
          that.queryCondition.capImplementationStatus = "CAP WIP";
          that.isSubmit = true;
        } else if (status == "CQS_SUBMIT") {
          //以提交
          that.showButton = false; //已经提交不能编辑
          that.isdeleteFile = false; //已经提交不能删除附件

          that.isSubmit = true;
          that.isSave = false;
          that.otherInput = true;
          that.fromVisitPlan = true;
          that.isdeleteFile = false;
        } else if (status == "COMPLETED") {
          //CQS已下发
          that.showButton = false;
          that.isdeleteFile = false;

          that.isSubmit = true;
          that.isSave = false;
          that.otherInput = true;
          that.fromVisitPlan = true;
          that.isdeleteFile = false;
        } else if (status == "REJECT") {
          //拒绝之后 可以再次提交
          that.isSubmit = true;
          that.showAccessories = true; //拒绝之后 附件能上传
        } else if (status == "SP_DRAFT") {
          that.showButton = false;
          that.isdeleteFile = false;

          that.isSubmit = true;
          that.isSave = false;
          that.otherInput = true;
          that.fromVisitPlan = true;
          that.isdeleteFile = false;
        } else if (status == "SP_SUBMIT") {
          //最终供应商提交后，由CQS手动更新为CAP Final，endorsed by CQS. 其他字段都置灰
          //你需要控制 CAP Implementation Status 只能 在状态 为  SP提交（SP_SUBMIT）的时候 才能修改为CAP Final,endorsed by CQS
          that.isSubmit = true;
          that.isSave = false;
          that.otherInput = true;
          that.fromVisitPlan = true;
          that.isdeleteFile = false;
          that.AllInput = true; //能修改为CAP Final,endorsed by CQS
        } else if (status == "FINAL") {
          that.showButton = false;
          that.fromVisitPlan = true;
          that.otherInput = true;
          that.isdeleteFile = false;
        } else if (status == "CANCLE") {
          that.showButton = false;
          that.otherInput = true;
          that.fromVisitPlan = true;
          that.isdeleteFile = false;
        }else if (status == "TERMINATED") {
          that.showButton = false;
          that.otherInput = true;
          that.fromVisitPlan = true;
          that.isdeleteFile = false;
        }
        // 清除自动触发的表单验证
        that.$nextTick(() => {
          that.$refs["queryCondition"].clearValidate();
          this.categoryLevel1Name = that.queryCondition.type;
          this.categoryLevel2Name = that.queryCondition.category;
        });
      });
    },
    saveVisit() {
      let that = this;
      let supplierEmail = this.queryCondition.supplierEmail
      let mcdEmail = this.queryCondition.mcdEmail
      let validFlag = false;
      if (commonFun.isNotEmpty(supplierEmail)) {//如有值校验格式
        that.$refs.queryCondition.validateField('supplierEmail', (valid) => {
          if (valid) {
            validFlag = true
          }
        });
      }
      if (commonFun.isNotEmpty(mcdEmail)) {//如有值校验格式
        that.$refs.queryCondition.validateField('mcdEmail', (valid) => {
          if (valid) {
            validFlag = true
          }
        });
      }
      if (!validFlag) {
        let data = {
          msvReportDetails: this.PurposeList,
          msvNo: this.queryCondition.msvNo,
          year: !!this.queryCondition.year ? this.queryCondition.year : "",
          ttMsvReportId: !!this.ttMsvReportId ? this.ttMsvReportId : "",
          type: !!this.queryCondition.type ? this.queryCondition.type : "",
          category: !!this.queryCondition.category
            ? this.queryCondition.category
            : "",
          supplierCode: !!this.queryCondition.supplierCode
            ? this.queryCondition.supplierCode
            : "",
          plantName: !!this.queryCondition.plantName
            ? this.queryCondition.plantName
            : "",
          tmSupplierId: !!this.queryCondition.supplierCode
            ? this.queryCondition.tmSupplierId
            : "",
          createBy: !!this.queryCondition.createBy
            ? this.queryCondition.createBy
            : "",
          createDate: "",
          visitType: !!this.queryCondition.visitType
            ? this.queryCondition.visitType
            : "",
          supplierEmail: !!this.queryCondition.supplierEmail
            ? this.queryCondition.supplierEmail
            : "",
          mcdEmail: !!this.queryCondition.mcdEmail
            ? this.queryCondition.mcdEmail
            : "",
          attendeesSupplier: !!this.queryCondition.attendeesSupplier
            ? this.queryCondition.attendeesSupplier
            : "",
          attendeesMcd: !!this.queryCondition.attendeesMcd
            ? this.queryCondition.attendeesMcd
            : "",
          mgtRecap: !!this.queryCondition.mgtRecap
            ? this.queryCondition.mgtRecap
            : "",
          msvResult: !!this.queryCondition.msvResult
            ? this.queryCondition.msvResult
            : "",
          highScore: !!this.queryCondition.highScore
            ? this.queryCondition.highScore
            : "",
          mediumScore: !!this.queryCondition.mediumScore
            ? this.queryCondition.mediumScore
            : "",
          capImplementationStatus: !!this.queryCondition.capImplementationStatus
            ? this.queryCondition.capImplementationStatus
            : "",
          lowScore: !!this.queryCondition.lowScore
            ? this.queryCondition.lowScore
            : "",
          visitBeginDate: !!this.queryCondition.dataArr
            ? this.$options.filters["dateFormatFilter"](
              this.queryCondition.dataArr[0]
            )
            : "",
          visitEndDate: !!this.queryCondition.dataArr
            ? this.$options.filters["dateFormatFilter"](
              this.queryCondition.dataArr[1]
            )
            : "",
          ttMsvId: !!this.ttMsvId ? this.ttMsvId : "",
          ttMsvDetailId: !!this.ttMsvDetailId ? this.ttMsvDetailId : "",
          status: this.status
        };
        saveReport(data).then(res => {
          that.ttMsvReportId = res.data;
          if (res.meta.success) {
            that.$message({
              message: this.$t("common.saveSuccess"),
              type: "success"
            });

            if (that.month != null) {
              that.updateMonth();
            }
            this.getDetail(res.data);
            this.getLogList(res.data);
          }
        });
      }
    },
    submitVisitPlan() {
      let that = this;
      this.$refs.queryCondition.validate(valid => {
        if (valid) {
          let list = this.PurposeList;
          for (let i = 0, len = list.length; i < len; i++) {
            if (list[i].visitPurpose == null || list[i].visitPurpose == "") {
              that.$message({ message: "拜访目的为必填", type: "warning" });
              return;
            }
          }
          //测试说要先上传附件才能提交 bug：1521
          if (this.fileList.length < 1) {
            that.$message({ message: "请先上传附件", type: "warning" });
            return;
          }

          let data = {
            msvReportDetails: list,
            msvNo: this.queryCondition.msvNo,
            year: !!this.queryCondition.year ? this.queryCondition.year : "",
            ttMsvReportId: !!this.ttMsvReportId ? this.ttMsvReportId : "",
            type: !!this.queryCondition.type ? this.queryCondition.type : "",
            category: !!this.queryCondition.category
              ? this.queryCondition.category
              : "",
            supplierCode: !!this.queryCondition.supplierCode
              ? this.queryCondition.supplierCode
              : "",
            plantName: !!this.queryCondition.plantName
              ? this.queryCondition.plantName
              : "",
            tmSupplierId: !!this.queryCondition.supplierCode
              ? this.queryCondition.tmSupplierId
              : "",
            createBy: !!this.queryCondition.createBy
              ? this.queryCondition.createBy
              : "",
            createDate: "",
            visitType: !!this.queryCondition.visitType
              ? this.queryCondition.visitType
              : "",
            supplierEmail: !!this.queryCondition.supplierEmail
              ? this.queryCondition.supplierEmail
              : "",
            mcdEmail: !!this.queryCondition.mcdEmail
              ? this.queryCondition.mcdEmail
              : "",
            attendeesSupplier: !!this.queryCondition.attendeesSupplier
              ? this.queryCondition.attendeesSupplier
              : "",
            attendeesMcd: !!this.queryCondition.attendeesMcd
              ? this.queryCondition.attendeesMcd
              : "",
            mgtRecap: !!this.queryCondition.mgtRecap
              ? this.queryCondition.mgtRecap
              : "",
            msvResult: !!this.queryCondition.msvResult
              ? this.queryCondition.msvResult
              : "",
            highScore: !!this.queryCondition.highScore
              ? this.queryCondition.highScore
              : "",
            mediumScore: !!this.queryCondition.mediumScore
              ? this.queryCondition.mediumScore
              : "",
            capImplementationStatus: !!this.queryCondition
              .capImplementationStatus
              ? this.queryCondition.capImplementationStatus
              : "",
            lowScore: !!this.queryCondition.lowScore
              ? this.queryCondition.lowScore
              : "",
            visitBeginDate: !!this.queryCondition.dataArr
              ? this.$options.filters["dateFormatFilter"](
                this.queryCondition.dataArr[0]
              )
              : "",
            visitEndDate: !!this.queryCondition.dataArr
              ? this.$options.filters["dateFormatFilter"](
                this.queryCondition.dataArr[1]
              )
              : "",
            status: this.status,
            ttMsvReportId: parseInt(this.ttMsvReportId)
          };
          console.log(data);
          submitReport(data).then(res => {
            if (that.month != null) {
              that.updateMonth();
            }
            if (res.meta.success) {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.$router.push({
                path: `/visitReport`
              });
              // that.$router.go(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    //获取供应商附件
    getFiles2: function () {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.ttMsvReportId;
      attachment.tsReckindId = "spVisitReport";
      fileService.getFileList(attachment).then(fileRes => {
        this.fileList2 = fileRes;
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.visitPurposeList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.chineseValue
        };
      });
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    getLogList(id) {
      let data = {
        ttMsvReportId: id
      };
      getVisitReportLogList(id).then(res => {
        this.logList = res.data;
      });
    },

    init() {
      let that = this;
      addVisitPlanReportInit().then(res => {
        // this.$set(that.queryCondition.msv, "msvNo", res.data);
        that.queryCondition.msvNo = res.data;
        that.queryCondition.capImplementationStatus = "CAP WIP";
      });
    },
    //搜索供应商工厂
    searchSupplier(value) {
      let that = this;
      if (!value) {
        if (that.queryCondition.type) {
          this.$nextTick(() => {
            that.DestroyIncomeStatistics = true;
          });
          that.showSelSupplierDialog = true;
        } else {
          that.$message({
            type: "error",
            message: that.$t("visitPlan.PleaseSupplierType")
          });
        }
      }
    },
    typeChange(val) {
      this.categoryLevel1Name = val;
      this.categoryLevel2Name = "";
      this.queryCondition.category = "";
      this.DestroyIncomeStatistics = false; //为了重新渲染子组件
      if (val == "Food") {
        this.istypeFood = true;
        //Category必填
        this.getCategory(val);
      } else {
        this.istypeFood = false;
        this.categoryList = [];
      }
      this.queryCondition.supplierCode = "";
      this.queryCondition.plantName = "";
      this.queryCondition.tmSupplierId = "";
    },
    CategoryChange(val) {
      this.categoryLevel2Name = val;
      this.queryCondition.supplierCode = "";
      this.queryCondition.plantName = "";
      this.queryCondition.tmSupplierId = "-1";
      this.DestroyIncomeStatistics = false; //为了重新渲染子组件
    },
    //动态获取Category下拉框的值
    getCategory(value) {
      let that = this;
      let data = {
        categoryLevel1Name: value
      };
      getCategoryValue(data).then(res => {
        this.categoryList = res.data;
      });
    },
    selectSupplierMethod: function (supList) {
      console.log(supList);

      this.queryCondition.supplierCode = supList.supplierCode;
      this.queryCondition.tmSupplierId = supList.tmSupplierId;
      this.queryCondition.plantName = supList.supplierName;
      this.showSelSupplierDialog = false;
      this.$refs.queryCondition.validateField("plantName");
    },
    searchMcD(val) {
      let that = this;
      if (!val) {
        this.showUserDialog = true;
      }
    },
    selectMcD(list) {
      let that = this;
      let oldEmail = that.queryCondition.mcdEmail;
      let oldEmailSet = new Set();
      if (commonFun.isNotEmpty(oldEmail)) {
        oldEmailSet = new Set(oldEmail.split(","));
      }
      list.forEach(item => {
        oldEmailSet.add(item.email);
      });

      oldEmailSet.delete("");
      oldEmailSet.delete(null);

      that.queryCondition.mcdEmail = Array.from(oldEmailSet).join(",");
      that.$refs.queryCondition.validateField("mcdEmail");
      that.showUserDialog = false;

      //
      // that.queryCondition.mcdEmail = '';
      // list.forEach((item) => {
      //   // that.queryCondition.mcdEmail = that.queryCondition.mcdEmail+item.email+',';
      // });
      // that.queryCondition.mcdEmail = list.map(data => data.email).join(',');
      // that.$refs.queryCondition.validateField('mcdEmail');
      // that.showUserDialog = false
    },
    searchSupplierEmail(val) {
      if (!val) {
        // this.$nextTick(() => {
        //   this.DestroyUserDialog1 = true;
        // });
        this.showSupplierUserDialog = true;
      }
    },
    selectSupplierEmail(list) {
      let that = this;
      let oldEmail = that.queryCondition.supplierEmail;
      let oldEmailSet = new Set();
      if (commonFun.isNotEmpty(oldEmail)) {
        oldEmailSet = new Set(oldEmail.split(","));
      }
      list.forEach(item => {
        oldEmailSet.add(item.email);
      });
      oldEmailSet.delete("");
      oldEmailSet.delete(null);
      that.queryCondition.supplierEmail = Array.from(oldEmailSet).join(",");
      that.$refs.queryCondition.validateField("supplierEmail");
      that.showSupplierUserDialog = false;
    },
    closeDialog1() {
      this.DestroyUserDialog1 = false;
    },
    closeDialog2() {
      this.DestroyUserDialog2 = false;
    },
    //获取拜访目的
    getPurposeList() {
      let that = this;
      getVisitReportList(that.queryCondition).then(res => {
        let list = res.resultData;
        for (let i = 0, len = list.length; i < len; i++) {
          list[i].ids = i;
        }
        this.PurposeList = list;
        console.log(this.PurposeList);
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },
    downloadFileFDP: function (row) {
      console.log(row);
      fileService
        .downloadFileFDP(row, row.tmDocumentId, this.ttMsvReportId)
        .then(res => { });
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.ttMsvReportId;
      attachment.tsReckindId = "MSV_REPOR_CQS";
      fileService.getFileList(attachment).then(fileRes => {
        this.fileList = fileRes;
      });
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let len = _this.fileList.length
      if (len >= 1) {
        _this.$message.error(_this.$t('visitPlan.OnlyPdfOne'));
        return false;
      }
      const isPDF = item.file.type === "application/pdf";
      if (!isPDF) {
        _this.$message.error(_this.$t('visitPlan.OnlyPdf'));
        return false;
      }

      let formData = new FormData();
      formData.append("file", item.file);
      fileService
        .fileUpload(formData)
        .then(res => {
          console.log(res);
          //调用成功后调用后台方法进行文件关系维护
          let attachment = {};
          attachment.seq = "1";
          attachment.documents = res.data;
          attachment.tsRecId = this.ttMsvReportId;
          attachment.tsReckindId = "MSV_REPOR_CQS";
          fileService.saveFile(attachment).then(saveRes => {
            _this.getFiles();
          });
        })
        .catch(error => {
          //文件上传失败
          _this.$message({
            type: "error",
            message: _this.$t("common.fileUploadFailed")
          });
        });
    },

    addSubject() {
      let length = this.PurposeList.length;
      var list = {
        visitPurpose: "",
        serialNumber: length + 1
      };
      if (this.PurposeList == null) {
        this.PurposeList = [];
        this.PurposeList.push(list);
      } else {
        this.PurposeList.push(list);
      }
    },
    delSubject() {
      let that = this;
      let list = this.PurposeList;
      let val = this.$refs.PurposeList.selection;
      if (val.length == 0) {
        that.$message({ message: "请选择需要删除的数据", type: "warning" });
      } else {
        val.forEach(function (item, index) {
          // 遍历源数据
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.serialNumber === itemI.serialNumber) {
              list.splice(indexI, 1);
            }
          });
        });
        //删除后重新循环list
        list.forEach(function (item, index) {
          item.serialNumber = index + 1;
        });
        this.PurposeList = list;
      }
    },

    visitPlanDetai(id) {
      let that = this;
      let data = {
        ttMsvDetailId: { id }
      };
      getVisitPlanDetailInit(id).then(res => {
        this.$set(that.queryCondition, "year", res.data.msv.year.toString());
        this.$set(that.queryCondition, "category", res.data.category);
        this.$set(that.queryCondition, "type", res.data.type);
        this.$set(that.queryCondition, "plantName", res.data.plantName);
        this.$set(that.queryCondition, "tmSupplierId", res.data.tmSupplierId);
        this.$set(that.queryCondition, "supplierCode", res.data.supplierCode);
      });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then(res => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess")
        });
        //删除成功删除列表数据
        files.splice(index, 1);
      });
    },
    updateMonth() {
      let that = this;
      let data = {
        month: that.month,
        ttMsvDetailId: that.ttMsvDetailId,
        ttMsvReportId: that.ttMsvReportId
      };
      updateMsvDetailMonth(data).then(res => {
        console.log(res);
      });
    },

    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
    },
    goBack() {
      this.$router.push({ name: 'visitReportList' });
    },
    lowScoreChange(e) {
      this.queryCondition.lowScore = e.target.value
    },
    highScoreChange(e) {
      this.queryCondition.highScore = e.target.value
    },
    mediumScoreChange(e) {
      this.queryCondition.mediumScore = e.target.value
    },

    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_MSV:RISK_LEVEL"] = "TT_MSV:RISK_LEVEL";
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      mapObj["TT_MSV:VISIT_TYPE"] = "TT_MSV:VISIT_TYPE";
      mapObj["TT_MSV:CAP_IMPLEMENTATION_STATUS"] =
        "TT_MSV:CAP_IMPLEMENTATION_STATUS";
      mapObj["TT_MSV:RECAP"] = "TT_MSV:RECAP";
      mapObj["TT_MSV:RESULT"] = "TT_MSV:RESULT";
      mapObj["TT_MSV:VISITPURPOSE"] = "TT_MSV:VISITPURPOSE";
      // mapObj["TT_MSV:CATEGORYTYPE"] = "TT_MSV:CATEGORYTYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.typeList = res["TT_MSV:TYPE"];
        this.riskLevelList = res["TT_MSV:RISK_LEVEL"];
        this.visitTypeList = res["TT_MSV:VISIT_TYPE"];
        this.capImplementationStatusList =
          res["TT_MSV:CAP_IMPLEMENTATION_STATUS"];
        this.mgtRecapList = res["TT_MSV:RECAP"];
        this.msvResultList = res["TT_MSV:RESULT"];
        this.visitPurposeList = res["TT_MSV:VISITPURPOSE"];
        // this.categoryList = res["TT_MSV:CATEGORYTYPE"];
      });
    }
  },
  extends: commonFunction
};
</script>
<style  lang="scss">
.visitReportAdd {
  .el-form-item {
    width: 500px;
  }
  .el-date-editor {
    width: 100%;
  }
  .el-form-item__content {
    width: 240px;
  }
  .VisitDate {
    .el-form-item__content {
      width: 50%;
    }
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input {
    width: 240px;
  }
  .ReportTo {
    .el-textarea__inner {
      width: 90%;
    }
  }
  .smallIcons {
    background-color: #f5f7fa;
    color: #909399;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 15px;
    white-space: nowrap;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    box-sizing: border-box;
  }
  .ScoreClass {
    width: 280px;
    .el-form-item__content {
      width: 150px;
    }
    .el-form-item__label {
      width: 110px !important;
    }
  }
  .highScoreClass {
    width: 420px;
    .el-form-item__content {
      width: 150px;
    }
  }
}
.textareaClass .el-textarea__inner {
  display: block;
  resize: vertical;
  //padding: 5px 15px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding-right: 25px !important;
}
</style>
<style scoped  lang="scss">
.visitReportAdd {
  .el-table {
    margin-top: 10px;
  }

  .purposeList {
    .el-table__row {
      td:nth-child(3) {
        .cell {
          width: 90%;
          .el-autocomplete {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>

